import { Component, OnInit, Injector } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { RiesgoService } from '../../../services/riesgo/riesgo.service';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus, MessagesValid } from '../../../models/messages';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "LL"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-reg-adquirente',
  templateUrl: './reg-adquirente.component.html',
  styleUrls: ['./reg-adquirente.component.scss'],
  providers: [MessagesTitles, MessagesStatus, DatePipe, MessagesValid, {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class RegAdquirenteComponent implements OnInit {
  Label_Proveedor = environment.LABEL_PROVEEDOR;
  Label_Proveedores = environment.LABEL_PROVEEDORES;
  Label_Adquirente = environment.LABEL_ADQUIRENTE;
  Label_Adquirentes = environment.LABEL_ADQUIRENTES;
  Id_Ruc = environment.ID_RUC;
  msgError: any;
  datos = {
    Num_Doc_Identificacion: "",
  }
  empresa: any;
  loading: boolean = false;
  personaJuridica;
  departamento: any;
  provincia: any;
  distrito: any;
  depa: any;
  depafiltro: any;
  prov: any;
  provfiltro: any;
  dist: any
  distfiltro: any;
  titulo: string;
  editar: boolean = false;
  idEmpresa: string;
  form: FormGroup;
  user: any;
  DepaCombo: any;
  ProvCombo: any = [];
  DistCombo: any = [];
  tipoDocumentoElement: any;
  riesgoService: RiesgoService;
  empresasService: EmpresasService;
  loginService: LoginService;
  ruta: any;
  rucEmpresa: any;
  constructor(
    private injector: Injector,
    private datePipe: DatePipe,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private msgValid: MessagesValid
  ) {
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.empresasService = this.injector.get<EmpresasService>(EmpresasService);
    this.riesgoService = this.injector.get<RiesgoService>(RiesgoService);

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.form = new FormGroup({

      TipoEmpresa: new FormControl('A', [Validators.required]),
      Razon_Social: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Num_Doc_Identificacion: new FormControl('', [Validators.required]),
      Nombre_Comercial: new FormControl('', [Validators.required]),
      Tipo_Doc_Identificacion: new FormControl(this.Id_Ruc, [Validators.required]),
      Direccion_Fiscal: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Departamento: new FormControl({ value: "-", disabled: false }, [Validators.required]),
      Provincia: new FormControl({ value: "-", disabled: false }, [Validators.required]),
      Distrito: new FormControl({ value: "-", disabled: false }, [Validators.required]),
      Pais: new FormControl('Colombia', [Validators.required]),
      UBIGEO: new FormControl({ value: "010101", disabled: false }, [Validators.required]),
      Scoring_Puntaje: new FormControl({ value: "0", disabled: false }, [Validators.required]),
      Scoring_Fecha_Consulta: new FormControl({ value: this.datePipe.transform(Date(), "yyyy-MM-dd"), disabled: true }, [Validators.required]),
      Estado: new FormControl({ value: "A", disabled: true }, [Validators.required]),
      Usuario: new FormControl(this.user.Usuario, []),
        Campo_1: new FormControl('', []),
        Campo_2: new FormControl('', []),
        Campo_3: new FormControl('', []),
        Campo_4: new FormControl('', []),
        Campo_5: new FormControl('', []),
        Campo_6: new FormControl('', []),
        Campo_7: new FormControl('', [])

    });
    this.titulo = "Registrar pagador";
    this.activateRoute.params.subscribe(params => {
      if (params['id'] != undefined) {
        this.titulo = "Editar Pagador";

        this.editar = true;
        this.idEmpresa = params['id'];

        this.loading = true;
        this.empresasService.obtenerAdquirenteByRuc(this.idEmpresa)
          .subscribe(res => {
            this.empresa = res[0]
            this.departamento = res[0]['Departamento'];
            this.provincia = res[0]['Provincia'];
            this.distrito = res[0]['Distrito'];
            this.idEmpresa = res[0]['idEmpresa'];
            this.form.controls['Num_Doc_Identificacion'].setValue(res[0]['Num_Doc_Identificacion']);
            this.form.controls['Num_Doc_Identificacion'].disable();
            this.form.controls['Razon_Social'].setValue(res[0]['Razon_Social']);
            this.form.controls['Scoring_Puntaje'].setValue(res[0]['Scoring_Puntaje']);
            this.form.controls['Nombre_Comercial'].setValue(res[0]['Nombre_Comercial']);
            this.form.controls['Tipo_Doc_Identificacion'].setValue(res[0]['Tipo_Doc_Identificacion']);
            this.form.controls['Direccion_Fiscal'].setValue(res[0]['Direccion_Fiscal']);
            this.form.controls['Pais'].setValue(res[0]['Pais']);
            this.form.controls['Usuario'].setValue(this.user.Usuario);
            this.form.removeControl('Estado');
            this.form.removeControl('Condicion');
            this.form.removeControl('Alta_Fecha');
            this.form.removeControl('Alta_Canal');
            this.form.removeControl('Alta_Usuario');
            this.form.controls['UBIGEO'].setValue(res[0]['UBIGEO']);
            this.form.controls['Departamento'].setValue(res[0]['Departamento']);
            this.form.controls['Provincia'].setValue(res[0]['Provincia']);
            this.form.controls['Distrito'].setValue(res[0]['Distrito']);            
            this.form.controls['Campo_1'].setValue(res[0]['Campo_1']);
            this.form.controls['Campo_2'].setValue(res[0]['Campo_2']);
            this.form.controls['Campo_3'].setValue(res[0]['Campo_3']);
            this.form.controls['Campo_4'].setValue(res[0]['Campo_4']);
            this.form.controls['Campo_5'].setValue(res[0]['Campo_5']);
            this.form.controls['Campo_6'].setValue(res[0]['Campo_6']);
            this.form.controls['Campo_7'].setValue(res[0]['Campo_7']);
            this.form.removeControl('Scoring_Fecha_Consulta');
            this.loading = false;
          }, (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.error instanceof ErrorEvent) {
              console.error("Error Event");
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: this.Label_Proveedor.toUpperCase() + " no encontrado. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            })
          });
      }
    })
  }

  ngOnInit() {
    const rutas = this.router.url.split('/');
    this.ruta = rutas[2];
    this.rucEmpresa = sessionStorage.getItem('rucEmpresa');
    this.tipoDocumentoElement = this.Id_Ruc;
    if (this.editar == false) {

    }
    const elem = document.getElementById('button-oculto');
    if (elem) {
      elem.style.display = 'none';
    }
  }
  Regresar() {
    this.loginService.clickGuard = true;
    if (this.ruta === 'proveedor') {
      this.router.navigate(['/empresas/proveedor/listado']);
    } else {
      this.router.navigate(['/empresas/adquirente/listado']);
    }
  }
  cargarProvincia(idDepa: string) {
    this.form.controls['Departamento'].setValue(idDepa);
    this.loading = true;
    this.empresasService.obtenerProvincia(idDepa).subscribe(resp => {
      this.ProvCombo = resp;
      this.loading = false;
    }, err => {
      this.loading = false;
      console.log('err', err)
    });
  }
  cargarDistrito(idProv: string) {
    this.form.controls['Provincia'].setValue(idProv);
    this.loading = true;
    this.empresasService.obtenerDistrito(idProv).subscribe(resp => {
      this.DistCombo = resp;
      this.loading = false;
    }, err => {
      this.loading = false;
      console.log('err', err)
    });
  }

  setUbigeo(event) {
    this.form.controls['Distrito'].setValue(event);
    this.form.controls['UBIGEO'].setValue(event);
  }

  tipoDocumento(event) {
    this.form.controls['Tipo_Doc_Identificacion'].setValue(event);
  }

  validarNumDocumento() {

    if (this.form.controls['Num_Doc_Identificacion'].invalid) {

      Swal.fire({
        title: '¡Advertencia!',
        text: 'Número de identificación no válido.',
        type: 'warning',
        allowOutsideClick: true,
        heightAuto: false
      });
    }
    else {
      this.loading = true;
      this.riesgoService.riesgoRUC(this.datos).subscribe(res => {

        if (res['message']) {
          this.loading = false;
          Swal.fire({
            title: '¡Advertencia!',
            text: 'Número de identificación no válido.',
            type: 'warning',
            allowOutsideClick: true,
            heightAuto: false
          });
          this.crearFormulario();

        } else {

          this.personaJuridica = res;
          this.cargarCampos();
          this.loading = false;
        }

      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Data no encontrado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      })
    }


  }


  crearFormulario() {
    if (this.editar) {
      let cot = new FormControl({ value: this.datePipe.transform(Date(), "yyyy-MM-dd"), disabled: true }, [Validators.required]);
      this.form.addControl('Scoring_Fecha_Consulta', cot);
      let cot2 = new FormControl({ value: "", disabled: true }, [Validators.required]);
      this.form.addControl('Estado', cot2);
    } else {
      this.form = new FormGroup({
        TipoEmpresa: new FormControl('A', [Validators.required]),
        Razon_Social: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Num_Doc_Identificacion: new FormControl('', [Validators.required]),
        Nombre_Comercial: new FormControl('', [Validators.required]),
        Tipo_Doc_Identificacion: new FormControl({ value: "", disabled: false }, [Validators.required]),
        Direccion_Fiscal: new FormControl({ value: "", disabled: false }, [Validators.required]),
        Departamento: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Provincia: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Distrito: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Pais: new FormControl('', [Validators.required]),
        UBIGEO: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Scoring_Puntaje: new FormControl({ value: "0", disabled: true }, [Validators.required]),
        Scoring_Fecha_Consulta: new FormControl({ value: this.datePipe.transform(Date(), "dd-MM-yyyy"), disabled: true }, [Validators.required]),
        Estado: new FormControl({ value: "1", disabled: true }, [Validators.required]),
        Usuario: new FormControl(this.user.Usuario, []),
        Campo_1: new FormControl('', []),
        Campo_2: new FormControl('', []),
        Campo_3: new FormControl('', []),
        Campo_4: new FormControl('', []),
        Campo_5: new FormControl('', []),
        Campo_6: new FormControl('', []),
        Campo_7: new FormControl('', [])
      });
    }
  }


  cargarCampos() {

    this.loading = true;
    this.empresasService.obtenerDepartamento().subscribe(res => {
      this.DepaCombo = res;
      this.depa = this.DepaCombo.filter(depas => depas.cDesUBIGEO == this.personaJuridica.Departamento);
      if (this.depa.length > 0) {
        this.depafiltro = this.depa[0].idUBIGEO;
        this.empresasService.obtenerProvincia(this.depafiltro).subscribe(resp => {
          this.ProvCombo = resp;
          this.prov = this.ProvCombo.filter(depas => depas.cDesUBIGEO == this.personaJuridica.Provincia)
          this.provfiltro = this.prov[0].idUBIGEO;
          this.empresasService.obtenerDistrito(this.provfiltro).subscribe(respu => {
            this.DistCombo = respu;
            this.dist = this.DistCombo.filter(depas => depas.cDesUBIGEO == this.personaJuridica.Distrito)
            this.distfiltro = this.dist[0].idUBIGEO;
            this.crearFormulario();
            this.form.controls['Scoring_Fecha_Consulta'].setValue(this.datePipe.transform(Date(), "yyyy-MM-dd"));

            this.form.controls['Num_Doc_Identificacion'].setValue(this.personaJuridica.Documento);
            this.form.controls['Razon_Social'].setValue(this.personaJuridica.RazonSocial);
            this.form.controls['Nombre_Comercial'].setValue(this.personaJuridica.RazonSocial);
            this.form.controls['Direccion_Fiscal'].setValue(this.personaJuridica.NomVia + " - " + this.personaJuridica.NumPredio);
            this.form.controls['Departamento'].setValue(this.depafiltro);
            this.form.controls['Provincia'].setValue(this.provfiltro);
            this.form.controls['Distrito'].setValue(this.distfiltro);
            this.form.controls['Scoring_Puntaje'].setValue(this.personaJuridica.ScoreBuro);
            this.form.controls['Tipo_Doc_Identificacion'].setValue(this.Id_Ruc);
            this.form.controls['UBIGEO'].setValue(this.distfiltro);
            switch (this.personaJuridica.EstadoContribuyente) {
              case 'ACTIVO': this.form.controls['Estado'].setValue('A');
                break;
              case 'INHABILITADO-VENT.UNICA': this.form.controls['Estado'].setValue('X');
                break;
              default: this.form.controls['Estado'].setValue('B');
                break;
            }
            this.loading = false;
          }, err => {
            this.loading = false;
            console.log('err', err)
          });
        }, err => {
          this.loading = false;
          console.log('err', err)
        });
      } else {
        this.crearFormulario();
        this.form.controls['Scoring_Fecha_Consulta'].setValue(this.datePipe.transform(Date(), "yyyy-MM-dd"));

        this.form.controls['Num_Doc_Identificacion'].setValue(this.personaJuridica.Documento);
        this.form.controls['Razon_Social'].setValue(this.personaJuridica.RazonSocial);
        this.form.controls['Nombre_Comercial'].setValue(this.personaJuridica.RazonSocial);
        this.form.controls['Direccion_Fiscal'].setValue(this.personaJuridica.NomVia + " - " + this.personaJuridica.NumPredio);
        this.form.controls['Scoring_Puntaje'].setValue(this.personaJuridica.ScoreBuro);
        this.form.controls['Tipo_Doc_Identificacion'].setValue(this.Id_Ruc);
        this.form.controls['UBIGEO'].setValue(0);
        switch (this.personaJuridica.EstadoContribuyente) {
          case 'ACTIVO': this.form.controls['Estado'].setValue('A');
            break;
          case 'INHABILITADO-VENT.UNICA': this.form.controls['Estado'].setValue('X');
            break;
          default: this.form.controls['Estado'].setValue('B');
            break;
        }
        this.loading = false;
      }
    }, err => {
      console.log('err', err)
    });
  }


  guardarCambios() {
    if (this.form.invalid) {
      Swal.fire({
        title: '¡Formulario incompleto!',
        text: 'Complete el formulario.',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      return;
    }
    Swal.fire({
      title: '¡Espere!',
      text: 'Estamos guardando la información',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    if (this.editar) {
      this.empresasService.actualizarEmpresa(this.idEmpresa, this.form.getRawValue())
        .subscribe(respu => {
          this.empresasService.obtenerProveedores().subscribe(res => {
            sessionStorage.setItem('lstProvCbo', JSON.stringify(res));
            Swal.fire({
              title: "¡Éxito!",
              text: 'Pagador actualizado correctamente.',
              type: "success",
              allowOutsideClick: false,
              heightAuto: false
            }).then(resp => {
              if (resp.value == true) {
                this.goBack();
              }
            })
          });
        }, (err: HttpErrorResponse) => {
          this.msgStatus.getMessage(err.status);
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "Pagador no actualizado. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        })
    } else {
      this.empresasService.registrarEmpresa(this.form.getRawValue())
        .subscribe(respu => {
          this.empresasService.obtenerAdquirente().subscribe(res => {
            sessionStorage.setItem('lstAdqCbo', JSON.stringify(res));
            Swal.fire({
              title: "¡Éxito!",
              text: 'Pagador guardado correctamente.',
              type: "success",
              allowOutsideClick: false,
              heightAuto: false
            }).then(resp2 => {
              if (resp2.value == true) {
                this.goBack();
              }
            });
          });
        }, (err: HttpErrorResponse) => {
          if (err.error.error) {
            this.msgStatus.getMessage(err.status);
            Swal.fire({
              title: "¡Ocurrió un problema!",
              text: " " + this.Label_Adquirente + " " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          } else {
            this.msgValid.getValid(Object.keys(err.error));
            Swal.fire({
              title: "Formulario incompleto",
              text: "Debe completar los campos: " + this.msgValid.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          }
        })
    }
  }

  goBack() {
    this.loginService.clickGuard = true;
    this.router.navigate(['/empresas/adquirente/listado']);
  }

}
